import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, articlesSEO } from '@/mocks/photography';

export default function Articles() {
  return (
    <>
      <SEOHead data={articlesSEO} />
      <ScrollToTop />
      <Navbar />
      <main>
        <div className="pt-20 pb-16 px-6 md:px-10 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: '摄影指南' },
              ]}
            />

            <div className="mt-4 mb-10">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
                摄影指南
              </h1>
              <p className="text-foreground-600 text-sm max-w-xl">
                拍摄技巧、行业资讯、选购指南 — 关于写真，你想知道的都在这里
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h2 className="text-base font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <div className="flex items-center gap-3">
                        <span>{article.date}</span>
                        <span>{article.readTime}</span>
                      </div>
                      <span className="flex items-center gap-1 text-primary-500 font-medium">
                        阅读 <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}